/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SendInviteRequestBody,
  SendInviteRequestBody$Outbound,
  SendInviteRequestBody$outboundSchema,
} from "../components/sendinviterequestbody.js";

export type SendInviteSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SendInviteRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  sendInviteRequestBody: SendInviteRequestBody;
};

/** @internal */
export type SendInviteSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SendInviteSecurity$outboundSchema: z.ZodMiniType<
  SendInviteSecurity$Outbound,
  SendInviteSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function sendInviteSecurityToJSON(
  sendInviteSecurity: SendInviteSecurity,
): string {
  return JSON.stringify(
    SendInviteSecurity$outboundSchema.parse(sendInviteSecurity),
  );
}

/** @internal */
export type SendInviteRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SendInviteRequestBody: SendInviteRequestBody$Outbound;
};

/** @internal */
export const SendInviteRequest$outboundSchema: z.ZodMiniType<
  SendInviteRequest$Outbound,
  SendInviteRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    sendInviteRequestBody: SendInviteRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      sendInviteRequestBody: "SendInviteRequestBody",
    });
  }),
);

export function sendInviteRequestToJSON(
  sendInviteRequest: SendInviteRequest,
): string {
  return JSON.stringify(
    SendInviteRequest$outboundSchema.parse(sendInviteRequest),
  );
}
